import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import Image from "../../overrides/venia-ui/components/Image";
import Icon from "../Icon";
import defaultClasses from "./pickupPoint.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import image from "../../assets/images/pickup-point.png";
import { Link } from "../../drivers";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useIntl } from "react-intl";
import { distance } from "@Src_main/utils/generalUtils";
import { getStoreStatus } from "@Src_main/utils/storeHoursUtils";
import Modal from "@Components/Modal";
import StoreDetails from "@Components/StoreDetails";
export function formatDistance(distance) {
  if (distance < 1000) return distance.toFixed(0) + "m";else return (distance / 1000).toFixed(2) + "km";
}
var PickupPoint = _ref => {
  var {
    selectable,
    onSelect,
    store,
    choosedPosition,
    showStoreHours,
    classes: propsClasses,
    showDetailModal = false
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var classes = mergeClasses(defaultClasses, propsClasses);
  var linkUrl = formatMessage({
    id: "url.key.restaurants"
  }) + "/".concat(store.url_key);
  var title = store.frontend_name ? store.frontend_name : store.name;
  var address = store.address.address1;
  var distanceCalculated = choosedPosition ? distance(choosedPosition.latitude, choosedPosition.longitude, store.latitude, store.longitude) : null;
  var [isModalStoreDetailsOpen, setIsModalStoreDetailsOpen] = useState(false);
  var {
    isMobile
  } = useWindowSize();
  var store_preview_image_mobile = store.store_preview_image_mobile;
  var store_preview_image_desktop = store.store_preview_image_desktop;
  var store_preview_image = isMobile ? store_preview_image_mobile : store_preview_image_desktop;
  var storePreviewImage = store_preview_image ? store_preview_image : image;
  var storeStatus = getStoreStatus(store.store_hours);
  var storeHours = /*#__PURE__*/React.createElement("div", {
    className: "uk-text-dimgray store-hours ".concat(classes.hours)
  }, /*#__PURE__*/React.createElement("div", {
    className: "restaurant-hours uk-text-xsmall uk-flex uk-flex-column ".concat(classes.restaurant)
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-row uk-flex-left uk-flex-middle uk-text-bold  ".concat(storeStatus.isOpen ? "uk-text-success-alt" : "uk-text-emphasis")
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-shipping"
  }), /*#__PURE__*/React.createElement("div", {
    className: "days uk-padding-small uk-padding-remove-vertical uk-padding-remove-right ".concat(classes.days)
  }), /*#__PURE__*/React.createElement("div", {
    className: "time ".concat(classes.time)
  }), /*#__PURE__*/React.createElement("div", null, "Ora ", storeStatus.isOpen ? "aperto" : "chiuso")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "Oggi: ", storeStatus.todayHours.map(x => x.open + "-" + x.close).join(" / ")), /*#__PURE__*/React.createElement("div", null, "Domani: ", storeStatus.tomorrowHours.map(x => x.open + "-" + x.close).join(" / ")))));
  var contentPickupPoint = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.ContentImage
  }, /*#__PURE__*/React.createElement(Image, {
    alt: "Miscusi",
    src: storePreviewImage,
    displayPlaceholder: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column uk-flex-center uk-width-expand ".concat(classes.content)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.title, " uk-text-uppercase")
  }, title), showDetailModal ? /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.infoDot),
    onClick: e => {
      e.stopPropagation();
      setIsModalStoreDetailsOpen(true);
    }
  }, /*#__PURE__*/React.createElement("span", null, "i")) : null, address ? /*#__PURE__*/React.createElement("div", {
    className: classes.address
  }, store.address.address1) : null, /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-column ".concat(classes.info)
  }, distanceCalculated ? /*#__PURE__*/React.createElement("div", {
    className: "uk-flex ".concat(classes.distance)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-locator",
    color: "black"
  }), /*#__PURE__*/React.createElement("div", null, formatDistance(distanceCalculated))) : null), showStoreHours ? storeHours : null));
  var onCloseDetails = e => {
    e.stopPropagation();
    setIsModalStoreDetailsOpen(false);
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "component-pickup-point uk-flex ".concat(classes.root, " ").concat(selectable ? classes.selectable : "")
  }, onSelect ? {
    onClick: onSelect
  } : {}), !onSelect ? /*#__PURE__*/React.createElement(Link, {
    className: "uk-flex uk-width",
    to: linkUrl
  }, contentPickupPoint) : contentPickupPoint, showDetailModal && isModalStoreDetailsOpen ? /*#__PURE__*/React.createElement(Modal, {
    id: store.ls_store_id,
    nameClass: "modal-store-details",
    isOpen: !!isModalStoreDetailsOpen,
    onClose: onCloseDetails,
    modalDialogClass: "uk-height-xlarge uk-padding-medium-top",
    canBeClosed: true,
    modalCloseOutside: true,
    position: "uk-position-bottom section-full-rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-overflow-auto"
  }, /*#__PURE__*/React.createElement(StoreDetails, {
    store: store,
    showCta: false
  }))) : null);
};
export default PickupPoint;